import * as ActionsTypes from "../../../../common/constants/stateConstants";

/*---------------------------------------------GET-DETAIL-PACKAGE-------------------------------------------------*/
export const getPackageForSouscriptionAction = (payload) => {
  return {
    type: ActionsTypes.GET_PACKAGE_FOR_SOUSCRIPTION,
    payload,
  };
};

export const getPackageForSouscriptionSuccessAction = (payload) => {
  return {
    type: ActionsTypes.GET_PACKAGE_FOR_SOUSCRIPTION_SUCCESS,
    payload,
  };
};

export const getPackageForSouscriptionFailAction = (payload) => {
  return {
    type: ActionsTypes.GET_PACKAGE_FOR_SOUSCRIPTION_FAIL,
    payload,
  };
};

/*--------------------------------------------CREATION-NOUVELLE-SOUSCRIPTION-------------------------------------------------*/
export const creationNouvelleSouscriptionAction = (payload) => {
  return {
    type: ActionsTypes.CREATION_NOUVELLE_SOUSCRIPTION,
    payload,
  };
};

export const creationNouvelleSouscriptionSuccessAction = (payload) => {
  return {
    type: ActionsTypes.CREATION_NOUVELLE_SOUSCRIPTION_SUCCESS,
    payload,
  };
};

export const creationNouvelleSouscriptionFailAction = (payload) => {
  return {
    type: ActionsTypes.CREATION_NOUVELLE_SOUSCRIPTION_FAIL,
    payload,
  };
};

export const creationNouvelleSouscriptionReinitializationAction = (payload) => {
  return {
    type: ActionsTypes.CREATION_NOUVELLE_SOUSCRIPTION_REINITIALIZATION,
    payload,
  };
};

/*--------------------------------------------EXIST_FORFAIT_AVEC_MEME_EXERCICE_ET_OPERATION_SUP_A_1------------------------------------------------*/
export const existForfaitAvecMemeExerciceAction = (payload) => {
  return {
    type: ActionsTypes.EXIST_FORFAIT_AVEC_MEME_EXERCICE,
    payload,
  };
};

export const existForfaitAvecMemeExerciceSuccessAction = (payload) => {
  return {
    type: ActionsTypes.EXIST_FORFAIT_AVEC_MEME_EXERCICE_SUCCESS,
    payload,
  };
};

export const existForfaitAvecMemeExerciceFailAction = (payload) => {
  return {
    type: ActionsTypes.EXIST_FORFAIT_AVEC_MEME_EXERCICE_FAIL,
    payload,
  };
};

export const existForfaitAvecMemeExerciceReinitializationAction = (payload) => {
  return {
    type: ActionsTypes.EXIST_FORFAIT_AVEC_MEME_EXERCICE_REINITIALIZATION,
    payload,
  };
};

/*--------------------------------------------SOUSCRIPTIONS_SITUATION------------------------------------------------*/
export const getSouscriptionSituationAction = (payload) => {
  return {
    type: ActionsTypes.GET_SITUATION_FOR_SOUSCRIPTION,
    payload,
  };
};

export const getSouscriptionSituationSuccessAction = (payload) => {
  return {
    type: ActionsTypes.GET_SITUATION_FOR_SOUSCRIPTION_SUCCESS,
    payload,
  };
};

export const getSouscriptionSituationFailAction = (payload) => {
  return {
    type: ActionsTypes.GET_SITUATION_FOR_SOUSCRIPTION_FAIL,
    payload,
  };
};

export const getSouscriptionSituationReinitializationAction = (payload) => {
  return {
    type: ActionsTypes.EXIST_FORFAIT_AVEC_MEME_EXERCICE_REINITIALIZATION,
    payload,
  };
};
